import { defineComponent, onMounted, ref, watch } from 'vue';
import { useStore } from '@/plugins/vuex';
import Filters from '@/sections/shared/explore/model/Filter';
import FilterFields from '@/sections/shared/explore/model/Filter';

export default defineComponent({
  props: {
    filterField: String,
    action: {
      type: Function
    },
    tempFilters: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  setup(props) {
    const store = useStore();
    const value = ref<boolean>(false);

    onMounted(() => {
      if (props.filterField) {
        value.value = getComponentState();
      }
    });

    if (!props.tempFilters) {
      watch(
        () => store.getters['filterStore/filters'],
        (filters: Filters) => {
          value.value = getComponentState();
        },
        { deep: true }
      );
    }

    if (props.tempFilters) {
      watch(
        () => store.getters['filterStore/tempFilters'],
        (filters: Filters) => {
          value.value = getComponentState();
        },
        { deep: true }
      );
    }

    const getComponentState = (): boolean => {
      const payload = props.filterField as unknown as FilterFields;
      if (!props.tempFilters) {
        return store.getters['filterStore/getSwitchReverseState'](payload);
      }
      return store.getters['filterStore/getSwitchReverseTempState'](payload);
    };

    const handleChange = (val: boolean) => {
      props.action(props.filterField, val);
    };

    return {
      value,
      handleChange
    };
  }
});
